/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseRubricItem } from './BaseRubricItem';
const RubricItemParser = /* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([['id', codecNumber]]), BaseRubricItem);
export class RubricItem extends BaseRubricItem {
    static decode(input) {
        return RubricItemParser.decode(input).map(res => new RubricItem(res));
    }
    static unsafeDecode(input) {
        return RubricItem.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RubricItemParser.encode(data);
    }
    static schema() {
        return RubricItemParser.schema();
    }
}
